// 转换层，包含API数据结构转换、针对UI展示的结构处理等，可继续拆分为api-adapter.ts、ui-adapter.ts等
import type { LogListQuery } from './api';

export const searchLogAdapter = (model: Record<string, any>): LogListQuery => {
  const { operation_time, ...otherFields } = model;
  const newModel = { ...otherFields };

  // 时间范围建议拆分两个字段传递 Split 'pickup_date_time' array into two distinct fields
  if (Array.isArray(operation_time) && operation_time.length === 2) {
    [newModel.operation_time_start, newModel.operation_time_end] = operation_time;
  }

  return newModel;
};
